// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const Folder = createIcon(
  <path
    clipRule="evenodd"
    d="M4.81846 4.73633C3.76912 4.73633 2.91846 5.58699 2.91846 6.63633V17.3636C2.91846 18.4129 3.76912 19.2636 4.81846 19.2636H19.1821C20.2314 19.2636 21.0821 18.4129 21.0821 17.3636V6.63633C21.0821 5.58699 20.2314 4.73633 19.1821 4.73633H4.81846ZM4.71846 6.63633C4.71846 6.5811 4.76323 6.53633 4.81846 6.53633H12.0003V8.13571C12.0003 8.41185 12.2241 8.63571 12.5003 8.63571H19.2821V17.3636C19.2821 17.4188 19.2373 17.4636 19.1821 17.4636H4.81846C4.76323 17.4636 4.71846 17.4188 4.71846 17.3636V6.63633Z"
    fillRule="evenodd"
  />,
);
